import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListSpecialiteComponent } from './list-specialite/list-specialite.component';
import { FilterSpecialitesByNamePipe } from 'src/app/shared/pipes/filter-specialites-by-name/filter-specialites-by-name.pipe';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { SpecialiteModalDetailComponent } from './modal/specialite-modal-detail/specialite-modal-detail.component';
import { SpecialiteModalAjoutComponent } from './modal/specialite-modal-ajout/specialite-modal-ajout.component';

@NgModule({
	declarations: [
		ListSpecialiteComponent,
		SpecialiteModalDetailComponent,
		SpecialiteModalAjoutComponent
	],
	imports: [SharedModule, GestionDonneesModule],
	providers: [FilterSpecialitesByNamePipe]
})
export class SpecialitesModule {}
